"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Assign a staff to an order.
 * Can be done any number of time in possible order statuses
 * Can only be done when the order is in IN_PROGRESS or CREATED status
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    else {
        order.assignedTo = { id: event.staffId };
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=assignStaff.js.map